/** DUMMY transport: logs each event to the console. */
export class ConsoleTransport {
    async send(event) {
        console.debug('[metrics]', event.eventName, event);
    }
}
/** Fans a single event out to every registered transport, like analytics.js's multi-destination pipe. */
export class MultiTransport {
    transports;
    constructor(transports) {
        this.transports = transports;
    }
    async send(event) {
        // A failing destination must never block or drop the event for the others.
        await Promise.all(this.transports.map((transport) => transport.send(event).catch((error) => {
            console.error('[metrics] transport failed', error);
        })));
    }
    destroy() {
        for (const transport of this.transports) {
            transport.destroy?.();
        }
    }
}
